import { runSourceDocumentJob, SOURCE_DOCUMENT_JOB_TYPES } from '../../services/sourceDocumentJob.service';

/**
 * Drop-in replacement for AIService.generateContent's ICF call shape
 * (prompt, context, output, 'icf', sectionTitle) — same string result, but
 * run as a background job + poll instead of one long synchronous HTTP call.
 *
 * ICF generation can legitimately run for several minutes, and Azure App
 * Service's front-end load balancer drops any single request idle past
 * ~230s regardless of the client/server timeout settings — the connection
 * just disappears with no HTTP response, which axios.js's interceptor
 * reports as a generic "Network error. Please check your connection.",
 * indistinguishable from an actual network failure and with no way to tell
 * whether generation had in fact finished. Each individual start/poll
 * request here stays well under that limit no matter how long the
 * underlying generation takes.
 *
 * @param {string} prompt
 * @param {string} context
 * @param {string} output - prior section HTML, if any (same "output" arg AIService.generateContent takes)
 * @param {string} sectionTitle
 * @param {string} projectId
 * @param {(job: object) => void} [onProgress] - see sourceDocumentJob.service.js's pollSourceDocumentJob
 * @returns {Promise<string>} the generated HTML, same as generateContent's return value
 */
export async function generateIcfContentViaJob(prompt, context, output, sectionTitle, projectId, onProgress) {
  const jobResult = await runSourceDocumentJob(
    SOURCE_DOCUMENT_JOB_TYPES.ICF_GENERATE,
    { projectId, prompt, context, output, sectionTitle },
    { onProgress }
  );
  return jobResult.output;
}
